import gql from "graphql-tag";

export const CreatePayout = gql`
  mutation createPayout(
    $bankInfo: BankInfoInput
  ) {
    createPayout(bankInfo: $bankInfo)
  }
`;
